var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39934 22.1743C7.9179 20.5685 9.05478 19.2258 10.5529 18.4323L13.9354 16.6406C14.5861 16.296 15.393 16.5441 15.7377 17.1948C16.0824 17.8455 15.8343 18.6525 15.1836 18.9971L11.8011 20.7888C10.9069 21.2624 10.2389 22.0589 9.93696 22.9938C9.63561 23.9269 9.72304 24.9206 10.1677 25.7601C10.6124 26.5996 11.3853 27.2302 12.3266 27.5052C13.2696 27.7806 14.3038 27.6754 15.1979 27.2018L18.5805 25.4101C19.2312 25.0654 20.0381 25.3135 20.3828 25.9643C20.7275 26.615 20.4794 27.4219 19.8287 27.7666L16.4461 29.5583C14.9481 30.3518 13.1986 30.538 11.5789 30.0648C9.95743 29.5912 8.59849 28.4946 7.81123 27.0083C7.02397 25.522 6.88023 23.7817 7.39934 22.1743ZM20.1463 14.8596C19.8016 14.2089 20.0497 13.402 20.7004 13.0573L24.0829 11.2656C25.581 10.4721 27.3305 10.2859 28.9502 10.7591C30.5717 11.2327 31.9306 12.3293 32.7179 13.8156C33.5051 15.3019 33.6489 17.0422 33.1297 18.6496C32.6112 20.2554 31.4743 21.5981 29.9762 22.3916L26.5937 24.1833C25.943 24.528 25.136 24.2799 24.7914 23.6291C24.4467 22.9784 24.6948 22.1715 25.3455 21.8268L28.728 20.0351C29.6222 19.5615 30.2902 18.765 30.5921 17.8301C30.8935 16.897 30.806 15.9033 30.3614 15.0638C29.9167 14.2243 29.1438 13.5937 28.2025 13.3188C27.2595 13.0433 26.2253 13.1485 25.3311 13.6221L21.9486 15.4138C21.2979 15.7585 20.491 15.5104 20.1463 14.8596ZM14.5763 23.425C14.2316 22.7742 14.4797 21.9673 15.1304 21.6226L24.1505 16.8448C24.8012 16.5001 25.6081 16.7482 25.9528 17.399C26.2975 18.0497 26.0494 18.8566 25.3987 19.2013L16.3786 23.9791C15.7279 24.3238 14.921 24.0757 14.5763 23.425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/URL.e1323bf1987d6e68a9fede86fe817ba0.svg";
export { ForwardRef as ReactComponent };